/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchPropertyResultDto } from '../../models/search-property-result-dto';

export interface SearchForPropertyByViewPfi$Params {
  viewPfi: string;
}

export function searchForPropertyByViewPfi(
  http: HttpClient,
  rootUrl: string,
  params: SearchForPropertyByViewPfi$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchPropertyResultDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    searchForPropertyByViewPfi.PATH,
    'get',
  );
  if (params) {
    rb.path('viewPfi', params.viewPfi, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchPropertyResultDto>;
      }),
    );
}

searchForPropertyByViewPfi.PATH = '/search/property/view_pfi/{viewPfi}';
